import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const GaelicFootballIcon = observer('GaelicFootballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M8.90304 21.5084C9.87839 21.8258 10.9187 22 12 22C13.0689 22 14.0977 21.8294 15.0633 21.5189L14.08 17.6098C13.3629 17.6672 12.6544 17.7075 12.0263 17.7075C11.3911 17.7075 10.6736 17.6662 9.94831 17.6077L8.90304 21.5084Z'
                fill='fill'
            />
            <path
                d='M4.65889 18.7864C5.66456 19.8738 6.90784 20.7364 8.30738 21.293L9.30854 17.5521C7.96397 17.4243 6.66805 17.2469 5.89957 17.1329L4.65889 18.7864Z'
                fill='fill'
            />
            <path
                d='M2.60406 15.4289C2.98759 16.4796 3.54335 17.4468 4.23553 18.299L5.19256 17.0236H5.18836C5.18567 17.004 5.02651 15.8447 4.90472 14.5055L2.60406 15.4289Z'
                fill='fill'
            />
            <path
                d='M2.41496 9.14781C2.14635 10.0518 2 11.0088 2 12C2 12.982 2.14378 13.9304 2.40761 14.827L4.85114 13.8479C4.8037 13.2275 4.76908 12.6021 4.7671 12.0599C4.765 11.4835 4.79763 10.8167 4.84589 10.1574L2.41496 9.14781Z'
                fill='fill'
            />
            <path
                d='M5.59281 10.3433C5.55075 10.945 5.52264 11.542 5.52453 12.0578C5.52636 12.5546 5.55707 13.1299 5.60017 13.7092H18.4891C18.5435 13.0572 18.5826 12.4035 18.5805 11.8456C18.5788 11.3919 18.5498 10.8721 18.508 10.3433H5.59281Z'
                fill='fill'
            />
            <path
                d='M5.65164 14.3406C5.67773 14.634 5.70523 14.9214 5.73359 15.1926C5.78158 15.6516 5.82961 16.059 5.867 16.3629C5.90631 16.3688 5.94812 16.3754 5.99097 16.3818C6.41776 16.4452 7.01462 16.5294 7.69388 16.6139C9.06222 16.7842 10.7336 16.9501 12.0263 16.9501C13.3189 16.9501 14.9903 16.7842 16.3587 16.6139C17.0384 16.5294 17.6357 16.4452 18.0626 16.3818C18.1084 16.375 18.1522 16.367 18.1939 16.3608C18.2377 16.0408 18.2948 15.6036 18.3515 15.1085C18.3797 14.8628 18.4073 14.6045 18.4334 14.3406H5.65164Z'
                fill='fill'
            />
            <path
                d='M12.0263 6.97111C10.7323 6.97113 9.0594 7.13096 7.69072 7.29467C7.01101 7.37598 6.41382 7.45743 5.98676 7.51844C5.9454 7.52435 5.90507 7.52974 5.867 7.53524C5.82816 7.85517 5.77826 8.2894 5.72833 8.78012C5.6982 9.07627 5.66933 9.39093 5.64219 9.71194H18.4513C18.4182 9.36824 18.3834 9.03015 18.3463 8.71394C18.2918 8.25104 18.2372 7.84092 18.195 7.5363C18.1543 7.5304 18.1113 7.5248 18.0668 7.51844C17.6397 7.45741 17.0419 7.37603 16.3618 7.29467C14.9931 7.13095 13.3203 6.97112 12.0263 6.97111Z'
                fill='fill'
            />
            <path
                d='M4.22082 5.71783C3.54065 6.55902 2.99303 7.5119 2.61246 8.54586L4.89841 9.49553C4.97209 8.6546 5.06176 7.88243 5.12113 7.39657L5.18311 6.90808L4.22082 5.71783Z'
                fill='fill'
            />
            <path
                d='M8.31579 2.7028C6.90452 3.26253 5.6508 4.13286 4.63998 5.23143L5.88066 6.76731C6.63326 6.65979 7.90738 6.49364 9.2371 6.37021L8.31579 2.7028Z'
                fill='fill'
            />
            <path
                d='M12 2C10.9224 2 9.88502 2.17201 8.91249 2.48745L9.87268 6.31243C10.6237 6.25286 11.3692 6.21369 12.0263 6.21368C12.6607 6.21368 13.3774 6.25102 14.1021 6.30717L15.1222 2.499C14.1396 2.17631 13.0905 2 12 2Z'
                fill='fill'
            />
            <path
                d='M14.7398 6.3639C16.1003 6.48816 17.4121 6.65886 18.1782 6.76836L19.3432 5.21567C18.3432 4.1338 17.1081 3.27375 15.7178 2.71646L14.7398 6.3639Z'
                fill='fill'
            />
            <path
                d='M18.8694 6.89967C18.8982 7.0899 19.0625 8.20428 19.1888 9.46192L21.397 8.57527C21.0138 7.52423 20.4585 6.55672 19.7666 5.70417L18.8694 6.89967Z'
                fill='fill'
            />
            <path
                d='M19.2487 10.1164C19.2989 10.7162 19.3359 11.318 19.338 11.8424C19.3403 12.4514 19.2954 13.1604 19.2361 13.8552L21.5892 14.8322C21.8541 13.9339 22 12.9841 22 12C22 11.0194 21.8555 10.0727 21.5924 9.17722L19.2487 10.1164Z'
                fill='fill'
            />
            <path
                d='M19.1762 14.5139C19.0504 15.7604 18.8937 16.8317 18.8684 17.0005L19.8401 18.2023C20.4954 17.3751 21.0247 16.4437 21.3938 15.4342L19.1762 14.5139Z'
                fill='fill'
            />
            <path
                d='M18.1624 17.1318C17.3901 17.2465 16.0771 17.4258 14.7177 17.5542L15.66 21.3045C17.1121 20.7329 18.3985 19.8342 19.4262 18.695L18.1624 17.1318Z'
                fill='fill'
            />
        </SvgElement>
    );
});
